import { FC, InputEvent } from 'react';

import { useTranslation } from 'react-i18next';
import SVGIcon from 'react-inlinesvg';

import IconSearch from '@assets/svg/icon-search.svg';

import styles from './index.module.scss';

type Props = {
	value: string;
	onInput: (value: string) => void;
};

export const SearchForm: FC<Readonly<Props>> = ({ value, onInput }) => {
	const { t } = useTranslation();

	return (
		<form className={styles.form} onSubmit={e => e.preventDefault()}>
			<SVGIcon src={IconSearch} />

			<input
				type="text"
				value={value}
				onInput={(e: InputEvent<HTMLInputElement>) => onInput((e.target as HTMLInputElement).value)}
				className={styles.field}
				placeholder={t('Source name')}
			/>
		</form>
	);
};

export default SearchForm;
